import { lazy, Suspense, useState, useEffect } from 'react';
import { SmoothScrollProvider } from './components/SmoothScrollProvider';
import Topbar from './components/Topbar';
import PageLoader from './components/PageLoader';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';

// Lazy load components below the fold for better performance
const Cursor = lazy(() => import('./components/Cursor'));
const ExperienceSection = lazy(() => import('./components/ExperienceSection'));
const WhyChooseUsSection = lazy(
  () => import('./components/WhyChooseUsSection'),
);
const PartnersSection = lazy(() => import('./components/PartnersSection'));
const ServicesSection = lazy(() => import('./components/ServicesSection'));
const TestimonialsSection = lazy(
  () => import('./components/TestimonialsSection'),
);
const ProcessSection = lazy(() => import('./components/ProcessSection'));
const ContactSection = lazy(() => import('./components/ContactSection'));
const BlogSection = lazy(() => import('./components/BlogSection'));
const CTASection = lazy(() => import('./components/CTASection'));
const Footer = lazy(() => import('./components/Footer'));

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Wait for PageLoader duration (should match PageLoader's hideTimer)
    const timer = setTimeout(() => setLoading(false), 2800);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="antialiased">
      <SmoothScrollProvider>
        <div className="hidden lg:block">
          <Topbar />
        </div>
        <Suspense fallback={<div />}>
          <Cursor />
        </Suspense>
        <main className="min-h-screen bg-white">
          <Navigation />
          <HeroSection />
          {/* <StatsSection /> */}
          {/* <ArticlesSection /> */}
          <section id="about">
            <AboutSection />
          </section>
          <Suspense fallback={<div className="h-screen" />}>
            <section id="experience">
              <ExperienceSection />
            </section>
            <section id="whychooseus">
              <WhyChooseUsSection />
            </section>
            <section id="partners">
              <PartnersSection />
            </section>
            {/* <VerticalTextSection /> */}
            <section id="services">
              <ServicesSection />
            </section>
            {/* <CaseStudiesSection /> */}
            <section id="testimonials">
              <TestimonialsSection />
            </section>
            <section id="process">
              <ProcessSection />
            </section>
            <section id="contact">
              <ContactSection />
            </section>
            <section id="blog">
              <BlogSection />
            </section>
            <section id="cta">
              <CTASection />
            </section>
            {/* <CareersSection /> */}
            <Footer />
          </Suspense>
        </main>
      </SmoothScrollProvider>
    </div>
  );
}

export default App;
